<template>
  <div class="tab-header">
    <UITab
      v-for="tab of tabs"
      :active="active == tab.id"
      :key="tab.id"
      :label="tab.label"
      :showIndicator="tab.showIndicator"
      @click="$emit('tabClicked', tab.id)"
    />
    <slot name="tabHeaderContent" />
  </div>
</template>

<script lang="ts">
import UITab from "./UITab.vue";
import type { PropType } from "vue";
import type { Tab } from "@/shared/ui/tabs/tab-container.vue";

export default {
  props: {
    active: String,
    tabs: Array as PropType<Tab[]>,
  },
  components: {
    UITab,
  },
};
</script>
